import { render, staticRenderFns } from "./Auktionen.vue?vue&type=template&id=d25604b4&"
import script from "./Auktionen.vue?vue&type=script&lang=js&"
export * from "./Auktionen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports